import { render, staticRenderFns } from "./EditRequestedChanges.vue?vue&type=template&id=7bf8aac3&"
import script from "./EditRequestedChanges.vue?vue&type=script&lang=js&"
export * from "./EditRequestedChanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports